import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Title } from '@nerdwallet/react-typography';
import StoryBlockStory from './story-block-story';

import { repeatable, titleInput } from '../../lib/editing-configs';

import styles from './story-block.module.less';

const StoryBlock = ({ title, stories }) => {
  const Stories = stories.map((story) => (
    <StoryBlockStory {...story} key={story.title} />
  ));

  return (
    <div className={styles['story-block__cont']}>
      <div className={styles['story-block-hdr__cont']}>
        <Title size="large" className={styles['story-block-hdr']}>
          {title}
        </Title>
      </div>
      <ul className={styles['story-block__stories']}>{Stories}</ul>
    </div>
  );
};

StoryBlock.displayName = 'StoryBlock';

StoryBlock.propTypes = {
  title: PropTypes.string,
  stories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkUrl: PropTypes.string,
      previewImg: PropTypes.string,
    })
  ),
};

StoryBlock.defaultProps = {
  title: '',
  stories: [],
};

StoryBlock.getEditingConfig = () => [
  titleInput,
  repeatable('stories', 'Elements', 'Element', () =>
    StoryBlockStory.getEditingConfig()
  ),
];

export default StoryBlock;
